// extracted by mini-css-extract-plugin
export var label = "_bw-5";
export var slideContainer = "_bw-0";
export var slider = "_bw-1";
export var sliderLg = "_bw-4";
export var sliderMd = "_bw-3";
export var sliderSm = "_bw-2";